module.exports = __webpack_public_path__ + "static/img/lrs_shouwei_img@2x.509d718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lrsimages/rules/lrs_shouwei_img@2x.png
// module id = 5Ddp
// module chunks = 23